module.exports = "/static/assets/bd2d7b2437946f1add631d2a55997b2f.gif";